import { PropsWithChildren } from "react";
import { css, CSSObject, Interpolation } from "styled-components";

export const screenSizes = {
  smallMobile: 375,
  tablet: 768,
  desktop: 1024,
};

type MediaMixinType = "min" | "max";

const mediaMixin =
  (type: MediaMixinType) =>
  (size: number) =>
  (style: CSSObject | TemplateStringsArray, ...interpolations: Interpolation<{}>[]) => css`
    @media (${type}-width: ${size}px) {
      ${css(style, interpolations)};
    }
  `;

const minMediaMixin = mediaMixin("min");
const maxMediaMixin = mediaMixin("max");

export const media = {
  tablet: minMediaMixin(screenSizes.tablet),
  desktop: minMediaMixin(screenSizes.desktop),
  smallMobile: minMediaMixin(screenSizes.smallMobile),
  mobileOnly: maxMediaMixin(screenSizes.tablet - 1),
  tinyMobileOnly: maxMediaMixin(screenSizes.smallMobile - 1),
};
